@import '../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../../constants/screen-width-breakpoints.module.less';
@import (reference) '../../../../../constants/spacing.module.less';
@import (reference) 'ui-components/components/text/text.module.less';

.shipment-details-section-header {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.shipment-count {
  color: var(--default--text-color--15);
}

.shipment-details-section-content {
  padding: @space-0 @space-16 @space-24;
}

.shipment-value-container {
  display: flex;
  flex-flow: column nowrap;
}

.shipment-details-label-row {
  display: flex;
  flex-direction: row;
  column-gap: @space-8;
  align-items: center;
}

.shipment-details-label {
  width: fit-content;
}

.shipment-value {
  display: flex;
  gap: @space-8;
  align-items: center;
}

.title {
  gap: @space-8;
}
